import api from "./api";

const boardService = {
  // Get all boards with search
  getAllBoards: async (params = {}) => {
    const response = await api.get("/api/boards", { params });
    return response.data.data || response.data;
  },

  // Get board by ID
  getBoardById: async (id) => {
    const response = await api.get(`/api/boards/${id}`);
    return response.data.data || response.data;
  },

  // Create new board with file upload
  createBoard: async (boardData, imageFile = null) => {
    const formData = new FormData();
    formData.append("board_name", boardData.board_name);
    if (boardData.is_active !== undefined) {
      formData.append("is_active", boardData.is_active);
    }

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.post("/api/boards", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Update board with file upload
  updateBoard: async (id, boardData, imageFile = null) => {
    const formData = new FormData();
    formData.append("board_name", boardData.board_name);
    if (boardData.is_active !== undefined) {
      formData.append("is_active", boardData.is_active);
    }

    if (boardData.image_url !== undefined) {
      formData.append("image_url", boardData.image_url || "");
    }

    if (imageFile) {
      formData.append("image", imageFile);
    }

    const response = await api.put(`/api/boards/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data || response.data;
  },

  // Delete board
  deleteBoard: async (id) => {
    const response = await api.delete(`/api/boards/${id}`);
    return response.data.data || response.data;
  },
};

export default boardService;
